import React from 'react';
import { SelectMenu, SelectMenuOption } from '@scale/scaleui';
import { ArrayValueComparator } from '@scale/shared-types';

interface ArrayComparatorBuilderProps {
  name: string;
  existingValue?: ArrayValueComparator;
  updateProperty: (arg: ArrayValueComparator) => void;
  required?: boolean;
}

const comparatorOptions: SelectMenuOption<ArrayValueComparator>[] = Object.values(
  ArrayValueComparator,
).map(comparator => {
  return { id: comparator, name: comparator };
});

const ArrayComparatorBuilder: React.FC<ArrayComparatorBuilderProps> = ({
  name,
  existingValue,
  updateProperty,
  required,
}) => {
  return (
    <div className="flex flex-col items-start">
      <div className="flex items-center">
        {name && <div className="my-1 text-sm font-medium leading-6 text-neutral-700">{name}</div>}
      </div>
      <SelectMenu
        className="min-w-[135px]"
        options={comparatorOptions}
        selectedOptionId={existingValue ?? ArrayValueComparator.ContainsAny}
        setSelected={value => {
          updateProperty(value as ArrayValueComparator);
        }}
        required={required}
      />
    </div>
  );
};

export default ArrayComparatorBuilder;
